/**
 * @fileoverview Provides utility functions for measuring execution time. Includes `time` for timing asynchronous functions, `stopwatch` for manual timing, and `printTiming` for logging `Timing` data.
 */

import { info_block } from './logging'

export type Timing = {
  durationMs: number
  name: string
}

export async function time<T extends object>(
  name: string,
  fn: () => Promise<T>,
): Promise<T & { timing: Timing }> {
  const start = Date.now()
  const result = await fn()
  const end = Date.now()
  return { ...result, timing: { durationMs: end - start, name } }
}

export function stopwatch(name: string): { finish: () => Timing } {
  const start = Date.now()
  return {
    finish: () => ({ durationMs: Date.now() - start, name }),
  }
}

export function printTiming(name: string, timings: Timing[]) {
  const timingStrs = timings.map((t) => `${t.name}: ${t.durationMs}ms`).join('\n')
  info_block(`${name} Timing (${timings.reduce((acc, t) => acc + t.durationMs, 0)}ms)`, timingStrs)
}
